import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "components/MDButton";
import { Box, TextField } from "@mui/material";
import { PersonAdd } from "@mui/icons-material";
import { useAddProgramme } from "hooks/settingsHooks/useAddProgramme";
import { toast } from "sonner";

const AddProgrammePopup = () => {
  const [open, setOpen] = useState(false);
  const [programmename, setProgrammename] = useState("");
  const [programmecode, setProgrammecode] = useState("");
  const [programmeduration, setProgrammeduration] = useState("");
  const { addprogramme, error, isLoading, success, setError, setSuccess } =
    useAddProgramme();

  useEffect(() => {
    if (error) {
      toast.error("Failed to add programme");
    }
    if (success) {
      toast.success("Programme added successfully");
      handleClose();
    }
  }, [error, success]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addprogramme(programmecode, programmename, programmeduration);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setProgrammename("");
    setProgrammecode("");
    setProgrammeduration("");
    setError(null);
    setSuccess(null);
  };

  const handleNumericInput = (e, setter) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setter(value);
    } else {
      toast.warning("Warning", {
        description: "Please enter only numeric values.",
      });
    }
  };

  return (
    <div>
      <MDButton
        variant="contained"
        color="info"
        size="small"
        startIcon={<PersonAdd />}
        onClick={handleClickOpen}
      >
        Add Programme
      </MDButton>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: { padding: 20, borderRadius: 10 },
        }}
      >
        <DialogTitle>Add Programme</DialogTitle>
        <DialogContent>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <TextField
              label="Enter Programme name..."
              name="programmeName"
              value={programmename}
              onChange={(e) => setProgrammename(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Enter Programme Code e.g: BSE..."
              name="programmeCode"
              value={programmecode}
              onChange={(e) => setProgrammecode(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Enter Programme duration e.g: 4,3..."
              name="programmeDuration"
              value={programmeduration}
              onChange={(e) => handleNumericInput(e, setProgrammeduration)}
              fullWidth
              margin="normal"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose}>Cancel</MDButton>
          <MDButton
            onClick={handleSubmit}
            variant="contained"
            color="info"
            disabled={isLoading}
          >
            Submit
          </MDButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddProgrammePopup;
